class ReservedProductsForm extends HTMLElement {
  form = this.querySelector('form');
  productsTextarea = this.querySelector('textarea#contact-form__products');
  jewelerTextarea = this.querySelector('textarea#contact-form__jeweler');

  reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');
  reservedJeweler = JSON.parse(sessionStorage.getItem('reservedJeweler') || '{}');

  connectedCallback() {
    this.textarea = this.querySelector('textarea');
    this.quantityTranslation = this.dataset.quantityTranslation || 'Quantity';
    
    this.createTextareaValue();
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const klaviyoOptions = this.createKlaviyoOptions();

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/events?company_id=${klaviyoModulesObject.companyId}`,
        klaviyoOptions
      );

      if (response.ok) {
        this.clearSessionStorage();
        return this.form.submit();
      }

      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  }

  createTextareaValue() {
    this.productsTextarea.value = this.createProductListValue();
    this.jewelerTextarea.value = this.createJewelerValue();
  }

  createProductListValue() {
  const reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');
  return reservedProducts
    .map(
      (product) =>
        `${product.title} - ${product.sku} - ${product.price} - ${this.quantityTranslation}: ${product.quantity || 1}`
    )
    .join('\n');
  }


  createJewelerValue() {
    return `${this.reservedJeweler.name}\n${this.reservedJeweler.addressOne} ${this.reservedJeweler.addressTwo}\n${this.reservedJeweler.zip} ${this.reservedJeweler.city}\n${this.reservedJeweler.country}`;
  }

  formatForKlaviyo(text) {
    // Replace newlines with HTML line breaks for Klaviyo
    return text.replace(/\n/g, '<br>');
  }

  createKlaviyoOptions() {
    const formData = new FormData(this.form);

    return {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2025-04-15',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: 'Reserved order',
                },
              },
            },
            properties: {
              name: formData.get('contact[name]'),
              email: formData.get('contact[email]'),
              phone: formData.get('contact[phone]'),
              products: this.formatForKlaviyo(formData.get('contact[products]')),
              jeweler: this.formatForKlaviyo(this.createJewelerValue()),
              line_items: JSON.parse(sessionStorage.getItem('reservedProducts') || '[]'),
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: formData.get('contact[email]'),
                },
              },
            },
          },
        },
      }),
    };
  }

  clearSessionStorage() {
    sessionStorage.removeItem('reservedProducts');
    sessionStorage.removeItem('reservedJeweler');
  }
}

if (!customElements.get('reserved-products-form')) {
  customElements.define('reserved-products-form', ReservedProductsForm);
}
